import React, { Component, Fragment } from 'react';
import Snackbar from '@mui/material/Snackbar';
import './sidebar.scss';
import { Link, withRouter } from 'react-router-dom';
import $ from 'jquery';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { getSkills } from '../../ActionCreators/learnAction';
import NotificationPopover from './notificationPopover';
import { saveProfile } from '../../ActionCreators/addSkillAction';
import { markedRead } from '../../ActionCreators/notificationAction';
import { updateAlert, getNotifications, trackUserLogin, logOutUser, logOutFromDevices, getSearchSuggestion, getNextSuggestion, } from '../../ActionCreators/sidebarAction';
import { getProfileDetails } from '../../ActionCreators/profileAction';
import { getCompanyDetail, gerColorCodes, getPlans } from '../../ActionCreators/AdminAction/accountAction';
import { getContentList } from '../../ActionCreators/AdminAction/adminContentAction';
import { getTestList } from '../../ActionCreators/AdminAction/adminTestAction';
import { getRewardsList } from '../../ActionCreators/AdminAction/adminRewardAction';
import { clearErrors } from '../../ActionCreators/errorAction';
import { getRoleSkills, removeSkill, reorderSkills, searchSkills, addSkilltoSelected, getSuggestedSkills, updatejobTitles } from '../../ActionCreators/AdminAction/jobTitleAction';
import Modal from 'react-bootstrap/Modal';
import ReactPlayer from 'react-player';
import { withTranslation } from 'react-i18next';
import i18n from '../../i18n';
import InfiniteScroll from 'react-infinite-scroll-component';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import moment from 'moment';
import { convertToDates } from '../../utils/miscelleneous';

const getIntials = (name) => {
    if (name !== null) {
        let f = name?.split(' ')[0]
        let l = name?.split(' ')[1]
        return f?.split('')[0] + l?.split('')[0]
    }
}

class Sidebar extends Component {
    state = {
        active: 'Learn',
        activeTab: 'learn',
        target: null,
        profile_image: null,
        menuList: [
            {
                title: 'Learn',
                subMenu: [
                    {
                        value: "Skills",
                        pathname: "learn",
                        activeIcon: '/images/learn-active-icon.svg',
                        icon: "/images/learn-icon.svg",
                        id: "learn",
                    },
                    {
                        value: "Tests",
                        pathname: "tests",
                        activeIcon: '/images/test-active-icon.svg',
                        icon: "/images/test-icon.svg",
                        id: "tests",
                    },
                    {
                        value: "Mentors",
                        pathname: "mentors",
                        activeIcon: '/images/mentor-active-icon.svg',
                        icon: "/images/test-icon.svg",
                        id: "mentors",
                    },
                    {
                        value: "SkillPath Review",
                        pathname: "skillpath-review",
                        activeIcon: '/images/skillpath-review-active-icon.svg',
                        icon: "/images/test-icon.svg",
                        id: "skillpath-review",
                    },
                ]
            },
            {
                title: 'My Elite',
                subMenu: [
                    {
                        value: "Add Content",
                        pathname: "my-content",
                        activeIcon: '/images/content-active-icon.svg',
                        icon: "/images/content-icon.svg",
                        id: "my-content",
                    },
                    {
                        value: "Saved",
                        pathname: "saved",
                        activeIcon: '/images/saved-active-icon.svg',
                        icon: "/images/saved-icon.svg",
                        id: "saved",
                    },
                    {
                        value: "Analytics",
                        pathname: "analytics",
                        activeIcon: '/images/analytics-active-icon.svg',
                        icon: "/images/analytics-icon.svg",
                        id: "analytics",
                    },
                    {
                        value: "Rewards",
                        pathname: "rewards",
                        activeIcon: '/images/reward-active-icon.svg',
                        icon: "/images/reward-icon.svg",
                        id: "rewards",
                    },
                    {
                        value: "My Profile",
                        pathname: "profile",
                        activeIcon: '/images/profile-active-icon.svg',
                        icon: "/images/reward-icon.svg",
                        id: "profile",
                    },
                ]

            },
            {
                title: 'Admin Panel',
                subMenu: [
                    {
                        value: "Job Titles",
                        pathname: "job-titles",
                        activeIcon: '/images/job-title-active-icon.svg',
                        icon: "/images/job-title-icon.svg",
                        id: "job-titles",
                    },
                    {
                        value: "Users",
                        pathname: "users",
                        activeIcon: '/images/users-active-icon.svg',
                        icon: "/images/users-icon.svg",
                        id: "users",
                    },
                    {
                        value: "Manage Skills",
                        pathname: "manage-skills",
                        activeIcon: '/images/library-active-icon.svg',
                        icon: "/images/test-icon.svg",
                        id: "manage-skills",
                    },
                    {
                        value: "Mentors Connect",
                        pathname: "mentors-connect",
                        activeIcon: '/images/mentor-active-icon.svg',
                        icon: "/images/users-icon.svg",
                        id: "mentors-connect",
                    },
                    {
                        value: "Reports",
                        pathname: "reports",
                        activeIcon: '/images/report-active-icon.svg',
                        icon: "/images/users-icon.svg",
                        id: "reports",
                    },
                    {
                        value: "Manage Content",
                        pathname: "manage-content",
                        activeIcon: '/images/library-active-icon.svg',
                        icon: "/images/library-icon.svg",
                        id: "manage-content",
                    },
                    {
                        value: "Manage Tests",
                        pathname: "manage-tests",
                        activeIcon: '/images/test-active-icon.svg',
                        icon: "/images/test-icon.svg",
                        id: "manage-tests",
                    },
                    {
                        value: "Manage Rewards",
                        pathname: "manage-rewards",
                        activeIcon: '/images/reward-active-icon.svg',
                        icon: "/images/reward-icon.svg",
                        id: "manage-rewards",
                    },
                    {
                        value: "Account Details",
                        pathname: "account",
                        activeIcon: '/images/account-active-icon.svg',
                        icon: "/images/admin-dashboard-icon.svg",
                        id: "account",
                    },
                ]

            }
        ],
        sideMenuList: [
            {
                value: "Getting Started",
                pathname: "getting-started",
                activeIcon: '/images/gettingstarted.svg',
                icon: "/images/learn-icon.svg",
                id: "getting-started",
            },
            {
                value: "Learn",
                pathname: "learn",
                activeIcon: '/images/learn-active-icon.svg',
                icon: "/images/learn-icon.svg",
                id: "learn",
            },
            {
                value: "Tests",
                pathname: "tests",
                activeIcon: '/images/test-active-icon.svg',
                icon: "/images/test-icon.svg",
                id: "tests",
            },
            {
                value: "Rewards",
                pathname: "rewards",
                activeIcon: '/images/reward-active-icon.svg',
                icon: "/images/reward-icon.svg",
                id: "rewards",
            },
            {
                value: "Analytics",
                pathname: "analytics",
                activeIcon: '/images/analytics-active-icon.svg',
                icon: "/images/analytics-icon.svg",
                id: "analytics",
            },
            {
                value: "Add Content",
                pathname: "my-content",
                activeIcon: '/images/content-active-icon.svg',
                icon: "/images/content-icon.svg",
                id: "my-content",
            },
            {
                value: "Saved",
                pathname: "saved",
                activeIcon: '/images/saved-active-icon.svg',
                icon: "/images/saved-icon.svg",
                id: "saved",
            },


        ],
        initial: '',
        showPopover: false,
        stepsEnabled: true,
        isIntroJsComplete: false,
        isIntroJsAndMobileView: false,
        isVideoDisplayed: true,
        initialStep: 0,
        admin: false,
        searchTerm: '',
        expand: true,
        isVideoPlayed: false,
        searchbar: false,
        page: 1,
        isSkill: false,
        isConfirm: false,
        // isIntro:false,
        contents: true,
        tests: false,
        rewards: false
    }

    componentDidMount = async () => {
        if (window.location.pathname === '/user-dashboard') {
            this.props.history.push('/learn');
        }
        document.body.classList.remove('background-red');
        document.documentElement.classList.remove('full-height');
        await this.props.getPlans();
        await this.props.getCompanyDetail();
        await this.props.gerColorCodes();

        if (localStorage.getItem('role')?.includes('admin')) {
            //    if (!localStorage.getItem('adminMenu')) {
            //     localStorage.setItem('adminMenu', JSON.stringify({content:false,test:false,reward:false}));
            //    }
            //    else{
            let startDate = '2021-01-01'
            let endDate = convertToDates(moment().subtract(0, 'days').toDate()); // February 28, 2015         
            await this.props.getTestList(1);
            if (this.props.testList?.length) {
                this.setState({
                    tests: true
                })
            }
            await this.props.getRewardsList(1, startDate, endDate);
            if (this.props.rewardList?.length) {
                this.setState({
                    rewards: true
                })
            }
            // }
        }

        if (localStorage.getItem('skill_added') === 'undefined') {
            localStorage.setItem('skill_added', false);
        }

        this.updateDimensions();
        if (window.location.pathname === '/learn/skill-explorer') {
            this.setState({
                expand: false
            })
        }
        this.setState({
            activeTab: window.location.pathname?.split('/')[1]
        }, () => {
            if (localStorage.getItem('profileComplete') === 'false') {
                this.props.history.push('/add-skills')
            }
        })
        i18n.changeLanguage(localStorage.getItem('i18nextLng'));

        if (window.innerWidth < 767 && (window.location.pathname?.split('/')[1] === 'more' || window.location.pathname.split('/')[1] === 'profile' || window.location.pathname.split('/')[1] === 'saved' || window.location.pathname.split('/')[1] === 'likes')) {
            this.setState({
                activeTab: 'more'
            })
        }

        this.setState({
            logo: this.props.companyDetails?.logo
        }, () => {
            localStorage.getItem('logo', this.state.logo)
        })
        await this.props.getProfileDetails();
        // this.setState({
        //     jobtitle: this.props.profiledetails?.current_job?.title,
        //     jobTitleId: this.props.profiledetails?.current_job?._id,
        //     skill_added: this.props.profiledetails?.skill_added
        // }, () => {
        //     localStorage.getItem('role').includes('admin') && window.location.pathname !== '/users' && this.props.getRoleSkills(this.state.jobTitleId, this.state.title);
        //     localStorage.getItem('role').includes('admin') && this.props.getSuggestedSkills(this.state.jobTitleId)
        // })
        this.props.getNotifications();
        this.props.trackUserLogin();
        if (JSON.parse(localStorage.getItem("profileDetails")) !== null && JSON.parse(localStorage.getItem("profileDetails") !== undefined)) {
            let profileDetailsMain
            profileDetailsMain = JSON.parse(localStorage.getItem("profileDetails"));
            this.setState({
                firstName: profileDetailsMain.firstName,
                lastName: profileDetailsMain.lastName,
                avatar: profileDetailsMain.avatar,
                color: profileDetailsMain.color,
                initial: profileDetailsMain.initial,
                profileComplete: profileDetailsMain.profile_complete,
                profileScore: profileDetailsMain.profile_score,
                rank: profileDetailsMain.rank,
                title: profileDetailsMain?.current_job?.title,
                jobTitleId: profileDetailsMain?.current_job?._id,
                skill_added: profileDetailsMain?.skill_added
            },
                () => {
                    // localStorage.setItem('skill_added', profileDetailsMain?.skill_added)
                    setTimeout(() => {
                        this.setState({
                            isIntroJsComplete: JSON.parse(localStorage.getItem("introComplete"))
                        });
                    }, 2000);

                })
        }

    }

    componentDidUpdate = (prevProps, prevState) => {
        if (prevState.activeTab !== this.props.history.location.pathname.split('/')[1]) {
            this.setState({
                activeTab: window.location.pathname.split('/')[1]
            }, () => {
                // this.props.getAlerts();
                this.setState({
                    open: false
                })
            })
        }
    }


    changeGet() {
        if ($(".introjs-button").hasClass("introjs-donebutton")) {
            $(".introjs-tooltipbuttons").addClass("intro-last-step");
        } else {
            $(".introjs-tooltipbuttons").removeClass("intro-last-step");
        }
    }
    logout = async () => {
        await this.props.logOutUser();
        // this.props.history.push('/login');
        window.location.href = '/login';
    }

    logoutFromDevice = async () => {
        await this.props.logOutFromDevices();
        this.props.history.push('/login');
    }

    isSidebar = () => {
        if ($("body").hasClass("BodyCloseNav")) {
            document.body.classList.remove("BodyCloseNav");
            document.body.classList.add("scrollhidden");
        } else {
            document.body.classList.add("BodyCloseNav");
            document.body.classList.remove("scrollhidden");
        }
    };
    updateDimensions = () => {
        let w = window.screen.width;
        if (w <= 1024) {
            document.body.classList.add("BodyCloseNav");
        } else {
            document.body.classList.remove("BodyCloseNav");
            document.body.classList.add("scrollhidden");
        }
        if (w <= 1024) {
            this.setState({ isIntroJsAndMobileView: true });
        } else {
            this.setState({ isIntroJsAndMobileView: false });
        }
    };
    isTabActive = (pathname) => {
        this.setState({
            activeTab: pathname
        }, () => {
            if (this.state.activeTab === 'admin-panel') {
                this.setState({
                    admin: !this.state.admin,
                    activeTab: this.state.admin ? 'users' : this.state.activeTab
                })
            }
        });
        if (window.innerWidth < 767) {
            document.body.classList.add("BodyCloseNav");
            document.body.classList.remove("scrollhidden");
        }

    }


    goToNotification = () => {
        this.props.history.push('/notifications')
    }




    redirectProfile = () => {
        this.props.history.push('/profile')
    }



    redirectToResources = (id, read, action) => {
        if (read) {
            window.location.href = action
        }
        else {
            this.props.markedRead(id, action)
        }
    }


    redirectToAchievers = (id, read, action) => {
        if (read) {
            window.location.href = '/analytics?tab=leaderboard';
        }
        else {
            this.props.markedRead(id, '/analytics?tab=leaderboard');
        }
    }


    checkFocus = () => {
        // dummy element
        let dummyEl = document.getElementById("express-form-typeahead");
        // check for focus
        let isFocused = document.activeElement === dummyEl;
        if (isFocused) {
            this.setState({
                isFocused,
            });
        } else {
            this.setState({
                isFocused: false,
            });
        }
    };



    redirectToSaved = (id, rId, read, action) => {
        if (read) {
            window.location.href = `/saved/skill-pod?id=${rId}`
        }
        else {
            this.props.markedRead(id, `/saved/skill-pod?id=${rId}`)
        }
    }

    changeSearch = (e) => {
        this.setState({
            searchTerm: e.target.value,
            page: 1
        }, () => {
            if (e.which === 13 || e.keyCode === 13) {
                this.props.history.push({ pathname: '/search', state: { query: this.state.searchTerm } });
                $('.list-container').hide();
            }
            else {
                $('.list-container').show();
                clearTimeout(this.timer1);
                this.timer1 = setTimeout(this.getSkillQuery, 800);
            }
        })
    }

    getSkillQuery = () => {
        this.props.getSearchSuggestion(this.state.searchTerm, this.state.page)
    }

    goToSearch = () => {
        this.props.history.push({ pathname: '/search', state: { query: this.state.searchTerm } })
    }

    onProgress = (e) => {
        this.setState({
            duration: e?.playedSeconds
        })
    }

    selectSuggestion = (e, info) => {
        e.preventDefault();
        e.stopPropagation();
        this.setState({
            searchTerm: info.title,
        })
        $('.list-container').hide();
        this.props.history.push({ pathname: `/learn/skill-explorer`, state: { info: info } })
    }

    setSearch = (val) => {
        this.setState({
            searchTerm: val
        }, () => {
            $('.list-container').show();
            this.props.getSearchSuggestion(this.state.searchTerm, this.state.page)
        })
    }

    openSearchBar = () => {
        this.setState({
            searchbar: !this.state.searchbar
        })
    }

    fetchData = () => {
        this.setState({
            page: this.state.page + 1
        }, () => {
            this.props.getNextSuggestion(this.state.searchTerm, this.state.page)
        })
    }



    changeSkill = (val) => {
        clearTimeout(this.timer1);
        this.setState({
            skillQuery: val
        }, () => {
            this.timer1 = setTimeout(this.getSkillQuery1, 800);
        })
    }

    getSkillQuery1 = () => {
        this.props.searchSkills(this.state.skillQuery)
    }

    selectSkill = (item) => {
        this.setState({
            skillQuery: ''
        }, () => {
            this.props.addSkilltoSelected(item);
        })
    }

    handleOnDragEnd = async (result) => {
        if (!result.destination) return
        await this.props.reorderSkills(result);
    }

    updatejobTitle = async () => {

        let obj = {
            _id: this.props.roleId,
            title: this.props.jobTitle,
            skills: this.props.selectedJobTitleSkills.map(el => [{ skill_id: el.skill_id, weight: el.weight }][0])
        }
        await this.props.updatejobTitles(obj);
        await this.props.saveProfile('skill');
        await this.props.getProfileDetails();
        await this.props.getSkills(false);
        localStorage.setItem('skill_added', true);
        this.setState({
            isSkill: false
        })
    }

    openVideo = () => {
        this.setState({
            clickBtn: true
        })
    }

    closeVideo = () => {
        this.setState({ clickBtn: false })
    }

    closeModal = () => {
        this.setState({
            isConfirm: false
        })
    }

    setActive = (e, active) => {
        e.preventDefault();
        e.stopPropagation();
        if (this.state.active === active) {
            this.setState({
                active: ''
            })
        } else {
            this.setState({
                active
            })
        }
    }

    snackClosed = () => {
        this.props.clearErrors();
    }

    render() {
        const { profiledetails, searchSuggestions, selectedJobTitleSkills, skillSuggestions, jobTitle, theme } = this.props
        const { t } = this.props
        return (
            <Fragment >
                <Snackbar
                    anchorOrigin={{ vertical: 'bottom', horizontal: 'center', }}
                    open={this.state.succesEnable}
                    onClose={() => this.snackClosed()}
                    message={this.state.successMessageText}
                    autoHideDuration={4000}
                />
                {/* 
                {
                    localStorage.getItem('role') === 'user' && this.state.isIntroJsAndMobileView === false && JSON.parse(localStorage.getItem('profileComplete'))
                        && (this.state.isIntroJsComplete === false && this.state.isVideoDisplayed === true)
                        ? (
                            <div>
                                <Steps
                                    enabled={false}
                                    steps={this.state.steps}
                                    initialStep={this.state.initialStep}
                                    onExit={() => this.onExit()}
                                    options={options}
                                    // tooltipClass="introcomp"
                                    onAfterChange={() => this.changeGet()}
                                />
                            </div>
                        ) : null
                } */}
                {
                    (window.location.pathname === '/add-skills' || window.location.pathname === '/learn/skill-explorer' || this.props.isShow || window.location.pathname === '/capture-pic' || window.location.pathname === '/start-test' || window.location.pathname === '/test-report') ? null :
                        (window.innerWidth > 767 &&
                            <div className="side-bar" style={{ backgroundColor: theme?.sidebarBgColor }}>

                                <div className="menu-close">
                                    <button
                                        type="button"
                                        className="close"
                                        onClick={() => this.isSidebar()}
                                        aria-label="Close"
                                    >
                                        <span aria-hidden="true" style={{ color: '#fff' }}>&times;</span>
                                    </button>
                                </div>
                                {/* <img src='/images/chevron-right.svg' className='float-right' alt='' style={{ transform: 'rotate(180deg)', transition: '0.6s linear' }} onClick={() => this.setState({ expand: false })} /> */}
                                <div className='profile-overflow'>
                                    <div style={{ width: 250 }} className='w-230'>
                                        <div className='engg-details'>
                                            <div className="profile-side-bar">
                                                <div className="profile-side-bar-avatar" >
                                                    {profiledetails?.profile_image ? (
                                                        <div className='initial-circle' style={{
                                                            backgroundImage: `url(${profiledetails?.profile_image})`, backgroundRepeat: 'no-repeat',
                                                            backgroundPosition: 'center',
                                                            backgroundSize: 'cover'
                                                        }}>
                                                            {/* <img src={profiledetails?.profile_image} className="rounded-circle" alt='' /> */}
                                                        </div>
                                                    ) : profiledetails?.initial !== null ? (
                                                        <div style={{ background: profiledetails?.profile_image ? '' : '#8B7DF2' }} className="initial-circle">{profiledetails?.initial}</div>
                                                    ) : (
                                                        <div style={{ background: '#8B7DF2' }} className="initial-circle">{getIntials(localStorage.getItem('name'))}</div>
                                                    )}
                                                </div>
                                            </div>

                                            <div className="profile-details">
                                                <h3 >{profiledetails?.firstName} {profiledetails?.lastName}</h3>
                                                <h4>{profiledetails?.current_job?.title}</h4>
                                            </div>
                                            {
                                                profiledetails?.rank == null ?
                                                    <div className="profile-score p-4">
                                                        <div className='row justify-content-center'>
                                                            <div className="tooltip1">
                                                                <div className='col-md-5 d-flex align-items-center' >
                                                                    <img src='/images/star-white.svg' width={28} alt='' />
                                                                    &nbsp;&nbsp;
                                                                    <h3 style={{ color: theme?.textColor }}>{profiledetails?.engagement_score !== null ? profiledetails?.engagement_score : 0}</h3>
                                                                </div>
                                                                <span className="tooltiptext">{t('Engagement Score')}</span>
                                                            </div>
                                                        </div>
                                                    </div> :
                                                    <div className="profile-score p-4">
                                                        <div className='row justify-content-center'>
                                                            <div className="tooltip1">
                                                                <div className='col-md-5 pl-0 d-flex align-items-center' >
                                                                    <img src='/images/trophy-white.svg' width={28} alt='' />
                                                                    &nbsp;&nbsp;
                                                                    <h3 style={{ color: theme.textColor }}>{profiledetails?.rank !== null ? profiledetails?.rank : 0}</h3>
                                                                </div>
                                                                <span className="tooltiptext">{t('Engagement Rank')}</span>
                                                            </div>

                                                            <div className="tooltip1">
                                                                <div className='col-md-5 pl-0 d-flex align-items-center' >
                                                                    <img src='/images/star-white.svg' width={28} alt='' />
                                                                    &nbsp;&nbsp;
                                                                    <h3 style={{ color: theme.textColor }}>{profiledetails?.engagement_score !== null ? profiledetails?.engagement_score : 0}</h3>
                                                                </div>
                                                                <span className="tooltiptext">{t('Engagement Score')}</span>
                                                            </div>
                                                        </div>
                                                    </div>
                                            }
                                        </div>
                                        <div className="dashboard-links mt-2" style={{ paddingLeft: localStorage.getItem('i18nextLng') === 'es' ? '0px' : 24 }}>
                                            {
                                                <ul>
                                                    <Link
                                                        to={`/getting-started`}
                                                    // onClick={() => this.isTabActive('getting-started')}
                                                    >
                                                        <li
                                                            style={{ backgroundColor: this.state.activeTab === 'getting-started' ? theme.bgColor : '', color: theme.textColor }}
                                                            onClick={() => this.isTabActive('getting-started')}
                                                            className={
                                                                this.state.activeTab === 'getting-started'
                                                                    ? "dashboard-active"
                                                                    : null
                                                            }
                                                        >
                                                            <img
                                                                src='/images/gettingstarted.svg'
                                                                alt=''
                                                            />
                                                            {t(`Getting Started`)}
                                                        </li>
                                                    </Link>
                                                    <div className='sidemenu-holder mt-1' id="accordion1">
                                                        {
                                                            this.state.menuList?.map((el, i) => {
                                                                if ((localStorage.getItem('role') === 'user' || localStorage.getItem('role')?.includes('mentor')) && el.title === 'Admin Panel') {
                                                                    return null
                                                                }
                                                                return (
                                                                    <div className="card">
                                                                        <div className={this.state.active === el.title ? "card-header" : "card-header collapsed"} data-toggle="collapse" href={`#collapse${i}`} onClick={(e) => this.setActive(e, el.title)} >
                                                                            <div style={{ marginLeft: 10, color: theme.textColor }}>
                                                                                {t(el.title)}
                                                                            </div>
                                                                        </div>
                                                                        <div className={this.state.active === el.title ? "collapse show mt-1" : "collapse mt-1"} data-parent="#accordion1">
                                                                            {
                                                                                el.subMenu.map(items => {
                                                                                    if (window.location.origin !== (process.env.NODE_ENV === 'development' ? ('http://localhost:4000') : 'https://edsanta.elitelearning.io') && (items.pathname === 'skillpath-review' || items.pathname === 'mentors-connect')) {
                                                                                        return null
                                                                                    }
                                                                                    return (
                                                                                        <Link
                                                                                            to={`/${items.pathname}`}
                                                                                        >
                                                                                            <li
                                                                                                style={{ paddingLeft: 10, backgroundColor: this.state.activeTab === items.pathname ? theme.bgColor : '', color: theme.textColor }}
                                                                                                id={items.id}
                                                                                                key={i}
                                                                                                onClick={() => this.isTabActive(items.pathname)}
                                                                                                className={
                                                                                                    this.state.activeTab === items.pathname
                                                                                                        ? "dashboard-active"
                                                                                                        : null
                                                                                                }
                                                                                            >
                                                                                                <img
                                                                                                    src={
                                                                                                        // this.state.activeTab === items.pathname
                                                                                                        items.activeIcon
                                                                                                        // : items.icon
                                                                                                    }
                                                                                                    alt=''
                                                                                                    width='16px'
                                                                                                />
                                                                                                {t(`${items.value}`)}
                                                                                            </li>
                                                                                        </Link>

                                                                                    )
                                                                                })
                                                                            }

                                                                        </div>

                                                                    </div>
                                                                )
                                                            })
                                                        }

                                                    </div>
                                                </ul>

                                            }

                                        </div>
                                    </div>
                                </div>
                                {
                                    // localStorage.getItem('role') === 'user' ?
                                    <div className='logo-footer'>
                                        <div style={{ background: '#fff', padding: '5px', width: '100%' }}>
                                            <div className='text-center' style={{ backgroundImage: `url(${this.props.companyDetails?.logo})`, backgroundPosition: 'center center', backgroundSize: "contain", backgroundRepeat: 'no-repeat', width: '100%', height: 65 }}>
                                                {/* <img src={localStorage.getItem('logo')} width={69} height={55} alt='' /> */}
                                            </div>
                                        </div>
                                        <p className='text-center mt-2' style={{ color: theme?.textColor, background: theme?.sidebarBgColor, fontSize: 12, fontFamily: 'Roboto' }}>
                                            <a style={{ textDecoration: 'underline', color: theme?.textColor }} href='https://elitelearning.io' target='_blank' rel='noreferrer'>Powered by Elite</a></p>
                                    </div>
                                }
                            </div>
                        )
                }
                {
                    (window.location.pathname === '/add-skills' || window.location.pathname === '/start-test' || window.location.pathname === '/test-report' || window.location.search.includes('skill_id') || (localStorage.getItem('external') !== null && localStorage.getItem('external'))) ? null :
                        <div className="dashboard-header" style={{ background: (window.innerWidth > 767 && window.location.pathname === '/learn/skill-explorer') ? theme?.sidebarBgColor : '' }} >
                            {
                                (window.innerWidth > 767 && (window.location.pathname === '/learn/skill-explorer')) ?
                                    <div className="mobile-logo" style={{ marginLeft: -295, background: '#fff', padding: 5, borderRadius: 4, minWidth: 60, height: 50, backgroundPosition: 'center', backgroundSize: 50, backgroundRepeat: 'no-repeat', backgroundImage: `url(${localStorage.getItem('logo')})`, cursor: 'pointer' }} onClick={() => this.props.history.push('/learn')}
                                    >
                                        {/* <img src={localStorage.getItem('logo')} alt='' width={50} /> */}
                                    </div> : null
                            }
                            <div className="Colapselink">
                                <button
                                    className="btn rounded-circle  d-block d-xl-none"
                                    onClick={() => this.isSidebar()}
                                >
                                    <img src="/images/colapselink.svg" alt='' />
                                </button>
                            </div>
                            {
                                window.innerWidth > 767 &&
                                ((window.location.pathname === '/learn' || window.location.pathname === '/tests' || window.location.pathname === '/analytics' || window.location.pathname === '/saved' || window.location.pathname === '/users' || window.location.pathname === '/job-titles' ||
                                    window.location.pathname === '/my-content' || window.location.pathname === '/mentors')
                                    ?
                                    <div style={{ width: '130px' }}>
                                        <button style={{ backgroundColor: theme?.bgColor }} className='tour-btn position-relative' id='pv' onClick={this.openVideo}><img src='/images/tour-icon.svg' alt='' /> &nbsp;Take a tour</button>
                                    </div>
                                    : null)
                            }

                            <div className="dashboard-header-heading"  >
                                <div className="mobile-logo d-block d-md-none" onClick={() => this.props.history.push('/learn')}
                                >
                                    <img src={localStorage.getItem('logo')} alt='' />
                                </div>
                                <div className='d-flex justify-content-between align-items-center' style={{ width: '35%' }}>
                                    <div className="d-md-none" onClick={() => this.setState({ open: !this.state.open })}>
                                        <img
                                            src="/images/search1.svg"
                                            width="24px"
                                            height="24px"
                                            alt=''
                                            style={{ marginTop: 3 }}
                                            autoFocus={true}
                                        />
                                    </div>
                                    <div className="d-md-none d-lg-none" onClick={() => this.props.history.push('/feeds')} style={{ background: '#9D99BF', padding: 2, borderRadius: 4, marginLeft: -5, marginTop: 0 }} >
                                        <img
                                            src="/images/random.svg"
                                            width="15px"
                                            height="15px"
                                            alt=''
                                        />
                                    </div>

                                    <div className="d-md-none d-lg-none"  >
                                        <NotificationPopover
                                            myData={
                                                this.props.notifications !== undefined &&
                                                this.props.notifications
                                            }
                                            redirectToAchievers={this.redirectToAchievers}
                                            redirectToResources={this.redirectToResources}
                                            redirectToSaved={this.redirectToSaved}
                                            goToNotification={this.goToNotification}
                                            unread={this.props.unread}
                                            theme={this.props.theme}
                                        />

                                    </div>

                                </div>
                                {
                                    this.state.open ?
                                        <div className='position-relative w-100'>
                                            <div className='d-flex align-items-center'>
                                                <input name='search' type='search' autoFocus className='form-control mt-2' value={this.state.searchTerm} style={{ width: '100%' }} autoComplete='off' placeholder='Type and Search Skill' onChange={(e) => this.setSearch(e.target.value)} />&nbsp;
                                                <img src='/images/search.svg' alt='' style={{ marginTop: 10 }} onClick={this.state.searchTerm !== '' ? this.goToSearch : null} />
                                            </div>
                                            {
                                                searchSuggestions !== undefined &&
                                                    searchSuggestions.length > 0 &&
                                                    this.state.searchTerm !== "" ? (
                                                    <div className="list-container" id="list-contain" style={{
                                                        maxHeight: '200px',
                                                        overflow: 'auto',
                                                        overflowX: 'hidden', borderBottomLeftRadius: 4, borderBottomRightRadius: 4
                                                    }}>

                                                        <InfiniteScroll
                                                            dataLength={searchSuggestions !== undefined && searchSuggestions.length} //This is important field to render the next data
                                                            next={this.fetchData}
                                                            hasMore={true}
                                                            scrollableTarget="list-contain"
                                                        >
                                                            <ul>
                                                                {
                                                                    searchSuggestions !== undefined &&
                                                                        searchSuggestions.length > 0 &&
                                                                        this.state.searchTerm !== ""
                                                                        ? searchSuggestions.map((items, i) => {
                                                                            return (
                                                                                <li key={items._id} onClick={(e) => this.selectSuggestion(e, items)}>
                                                                                    {items.title}
                                                                                </li>
                                                                            );
                                                                        })
                                                                        : null
                                                                }
                                                            </ul>
                                                        </InfiniteScroll>
                                                    </div>
                                                ) :
                                                    null
                                            }
                                        </div>
                                        : null
                                }
                            </div>

                            <div className='d-flex justify-content-end align-items-end text-right' >
                                <div>

                                    {
                                        window.innerWidth > 767 && (this.state.searchbar ?
                                            <div className='position-relative'>
                                                <div className="has-search w-100 position-relative"  >
                                                    <span className="form-control-feedback">
                                                        <img src="/images/search.svg" width="20px" height='20px' alt='' />
                                                    </span>
                                                    <input type='text' autoComplete='off' className='form-control' autoFocus={true} style={{ width: 400, borderRadius: 4 }} placeholder='Search Skills and topics' value={this.state.searchTerm} onKeyPress={(e) => this.changeSearch(e)} onChange={(e) => this.changeSearch(e)} />
                                                    <span className="form-control-feedback cursor-pointer" onClick={() => this.setState({ searchbar: false, searchTerm: '' })} style={{ right: 6, pointerEvents: 'auto', top: -4 }}>
                                                        <img src="/images/close.svg" width="15px" height='15px' alt='' />
                                                    </span>
                                                </div>
                                                {
                                                    searchSuggestions !== undefined &&
                                                        searchSuggestions.length > 0 &&
                                                        this.state.searchTerm !== "" ? (
                                                        <div className="list-container" id="list-contain" style={{
                                                            maxHeight: '200px',
                                                            overflow: 'auto',
                                                            overflowX: 'hidden', borderBottomLeftRadius: 4, borderBottomRightRadius: 4
                                                        }}>
                                                            <InfiniteScroll
                                                                dataLength={searchSuggestions !== undefined && searchSuggestions.length} //This is important field to render the next data
                                                                next={this.fetchData}
                                                                hasMore={true}
                                                                scrollableTarget="list-contain"
                                                            >
                                                                <ul>
                                                                    {
                                                                        searchSuggestions !== undefined &&
                                                                            searchSuggestions.length > 0 &&
                                                                            this.state.searchTerm !== ""
                                                                            ? searchSuggestions.map((items, i) => {
                                                                                return (
                                                                                    <li key={items?._id} onClick={(e) => this.selectSuggestion(e, items)}>
                                                                                        {items.title}
                                                                                    </li>
                                                                                );
                                                                            })
                                                                            : null}
                                                                </ul>
                                                            </InfiniteScroll>
                                                        </div>
                                                    ) :
                                                        null
                                                }
                                            </div>
                                            :
                                            <div className="animated-search1" onClick={this.openSearchBar}  >
                                                <img src='/images/search.svg' alt='' />
                                            </div>)
                                    }
                                </div>
                                &nbsp;
                                {
                                    window.innerWidth > 767 &&
                                    <div className='help-holder' >
                                        <a href='https://elitelearning.freshdesk.com/support/home' target='_blank' rel='noreferrer'>
                                            <div className="dropmain-holder1 d-inline-block cursor-pointer" style={{ marginTop: 4, marginLeft: 0 }}>
                                                <div className="bell">
                                                    <img src='/images/help1.svg' alt='' width={28} className='help' />
                                                </div>

                                            </div>
                                        </a>
                                    </div>
                                }&nbsp;
                                <div style={{ display: window.innerWidth > 767 ? 'block' : 'none' }}>
                                    <NotificationPopover
                                        myData={
                                            this.props.notifications !== undefined &&
                                            this.props.notifications
                                        }
                                        redirectToAchievers={this.redirectToAchievers}
                                        redirectToResources={this.redirectToResources}
                                        redirectToSaved={this.redirectToSaved}
                                        goToNotification={this.goToNotification}
                                        unread={this.props.unread}
                                        theme={this.props.theme}
                                    />
                                </div>

                                <div className="dashboard-profile-holder" style={{ display: window.innerWidth > 767 ? 'flex' : 'none' }}>
                                    <div className="dropmain-holder d-inline-block">
                                        <div
                                            className="drop-profile-hold initial-circle-custom"
                                            style={{ background: profiledetails?.profile_image ? '' : '#8B7DF2' }}
                                        >
                                            {profiledetails?.profile_image ? (
                                                <img
                                                    src={profiledetails?.profile_image} alt=''
                                                />
                                            ) : profiledetails?.initial !== null ? (
                                                profiledetails?.initial
                                            ) : getIntials(localStorage.getItem('name'))
                                            }
                                        </div>
                                        <div className="drop-inst">
                                            <div className="drop-banner" style={{ background: theme?.bgColor }}>
                                                <div
                                                    className="profile-banner-drop"
                                                    style={{ background: profiledetails?.profile_image ? '' : '#166B9C' }}

                                                >
                                                    {profiledetails?.profile_image ? (
                                                        <img src={profiledetails?.profile_image} alt='' />
                                                    ) : profiledetails?.initial ? (
                                                        <div style={{ color: '#fff', fontSize: 18 }} >{profiledetails?.initial}</div>
                                                    ) :
                                                        getIntials(localStorage.getItem('name'))
                                                    }
                                                </div>
                                                <div className="drop-profile-name" style={{ fontFamily: 'Roboto' }}>
                                                    {profiledetails?.firstName} {profiledetails?.lastName}                                                </div>
                                            </div>
                                            <ul>
                                                <li onClick={() => this.redirectProfile()}>
                                                    <div className="icons-holder">
                                                        <i className="fa fa-address-book-o"></i>
                                                    </div>
                                                    <div className="list-text">
                                                        <h4>{t('My Profile', { ns: 'profile' })}</h4>
                                                    </div>
                                                </li>

                                            </ul>
                                            <div style={{ color: theme?.bgColor }} className="logout" onClick={() => this.logout()}>
                                                {t('Logout')}
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                            {
                                ((localStorage.getItem('external') !== null && localStorage.getItem('external')) || window.location.pathname === '/start-test' || window.location.pathname === '/test-report' || window.location.search.includes('skill_id')) ? null :
                                    <div className="mobilefooter-links d-block d-md-none">
                                        {
                                            <ul>
                                                <Link
                                                    to='/learn'
                                                    onClick={() => this.isTabActive('learn')}
                                                >
                                                    <li
                                                        id="learn"
                                                    >
                                                        {
                                                            this.state.activeTab === 'learn' ?
                                                                <img
                                                                    src="/images/learn-active-icon.svg"
                                                                    alt=''
                                                                    className='dashboard-active'
                                                                />
                                                                : <img
                                                                    src="/images/learn-icon.svg"
                                                                    alt=''
                                                                />
                                                        }
                                                        <br />
                                                        <small style={{ color: this.state.activeTab === 'learn' ? '#8B7DF2' : '#9D99BF' }}>{t('Learn')}</small>
                                                    </li>
                                                </Link>
                                                <Link
                                                    to='/tests'
                                                    onClick={() => this.isTabActive("tests")}
                                                >
                                                    <li
                                                        id="tests"
                                                    >
                                                        {
                                                            this.state.activeTab === 'tests' ?
                                                                <img
                                                                    src="/images/test-active-icon.svg"
                                                                    alt=''
                                                                    className='dashboard-active'
                                                                />
                                                                : <img
                                                                    src="/images/test-icon.svg"
                                                                    alt=''
                                                                />
                                                        }

                                                        <br />
                                                        <small style={{ color: this.state.activeTab === 'tests' ? '#8B7DF2' : '#9D99BF' }}>{t('Tests')}</small>
                                                    </li>
                                                </Link>
                                                <Link
                                                    to='/rewards'
                                                    onClick={() => this.isTabActive("rewards")}
                                                >
                                                    <li
                                                        id="rewards"

                                                    >
                                                        {
                                                            this.state.activeTab === 'rewards' ?
                                                                <img
                                                                    src="/images/reward-active-icon.svg"
                                                                    alt=''
                                                                    className='dashboard-active'
                                                                />
                                                                : <img
                                                                    src="/images/reward-icon.svg"
                                                                    alt=''
                                                                />
                                                        }
                                                        <br />
                                                        <small style={{ color: this.state.activeTab === 'rewards' ? '#8B7DF2' : '#9D99BF' }}>{t('Rewards')}</small>
                                                    </li>
                                                </Link>
                                                <Link
                                                    to='/analytics'
                                                    onClick={() => this.isTabActive("analytics")}
                                                >
                                                    <li
                                                        id="analytics"

                                                    >
                                                        {
                                                            this.state.activeTab === 'analytics' ?
                                                                <img
                                                                    src="/images/analytics-active-icon.svg"
                                                                    alt=''
                                                                    className='dashboard-active'
                                                                />
                                                                : <img
                                                                    src="/images/analytics-icon.svg"
                                                                    alt=''
                                                                />
                                                        }<br />
                                                        <small style={{ color: this.state.activeTab === 'analytics' ? '#8B7DF2' : '#9D99BF' }}>{t('Analytics')}</small>
                                                    </li>
                                                </Link>


                                                <Link
                                                    to='/more'
                                                    onClick={() => this.isTabActive("more")}
                                                >
                                                    <li
                                                        onClick={() => this.isTabActive("more")}
                                                        id="more"

                                                    >
                                                        {
                                                            this.state.activeTab === 'more' ?
                                                                <img
                                                                    src="/images/more-active-icon.svg"
                                                                    alt=''
                                                                    className='dashboard-active'
                                                                />
                                                                : <img
                                                                    src="/images/menu-icon.svg"
                                                                    alt=''
                                                                />
                                                        }
                                                        <br />
                                                        <small style={{ color: this.state.activeTab === 'more' ? '#8B7DF2' : '#9D99BF' }}>{t('More')}</small>
                                                    </li>
                                                </Link>

                                            </ul>
                                        }
                                    </div>
                            }
                        </div>
                }
                {
                    this.state.open ?
                        <div
                            style={{
                                width: "100%",
                                height: 46,
                                // display: "none",
                                top: 60,
                                backgroundColor: "white",
                            }}
                            id="misc-div"
                        ></div> : null
                }
                {/* <Modal
                    show={this.props.openBounsModal}
                    size="lg"
                    aria-labelledby="contained-modal-title-vcenter"
                    centered
                    dialogClassName={"bonus-modal"}
                    style={{ backdropFilter: 'none' }}
                >
                    <div  >
                        <div className="sticky-close" onClick={() => this.closeBonus(this.props.bonus10 ? 'bonus10' : 'bonus20')}><img
                            src="/images/close.svg" alt='' /></div>

                    </div>
                    <Modal.Body>
                        <div className="d-flex flex-column justify-content-center align-items-center" style={{ padding: 25 }}>
                            <p>Bonus gift card unlocked!</p>
                            <h1 className="greet mt-2">CONGRATULATIONS !<br /></h1>
                            <div className='mt-4 d-flex align-items-center'>
                                <img src='/images/confetti-left.svg' alt='' />&nbsp;&nbsp;
                                <img src='/images/paytm.svg' alt='' style={{ borderRadius: 10 }} />&nbsp;&nbsp;
                                <img src='/images/confetti-right.svg' alt='' />&nbsp;&nbsp;

                            </div>
                            {
                                this.props.bonus10 ?
                                    <h2 className="text-center mt-4">You unlocked Rs 10 Paytm Voucher for completing the sign up process.</h2>
                                    :
                                    <h2 className="text-center mt-4">You unlocked Rs 20 Paytm Voucher for reaching 50 engagement score points.</h2>
                            }
                            <div className='redeem-btn1 mt-3'>
                                <button onClick={() => this.goToReward(this.props.bonus10 ? 'bonus10' : 'bonus20')} className="redeem">Redeem Now</button>
                            </div>
                        </div>
                    </Modal.Body>
                </Modal > */}


                {
                    window.location.pathname === '/learn' &&
                    <Modal
                        show={false}
                        // show={localStorage.getItem('role') === 'user,admin' && (localStorage.getItem('skill_added') === 'false')}
                        size="lg"
                        aria-labelledby="contained-modal-title-vcenter"
                        centered
                        dialogClassName={"add-skills-modal"}
                    >
                        <Modal.Body style={{ padding: '20px 40px 30px 40px', }}>
                            <h1 className='text-center'>{t('Edit Job Title ')}</h1>
                            <div className='job-title-input'>
                                <h3>Job Title</h3>
                                {
                                    this.state.jobtitle ?
                                        (
                                            // !this.state.isEdit ?
                                            <h1>
                                                {this.state.jobtitle}
                                                {/* &nbsp; <img src='/images/pencil-icon.svg' alt='' className='cursor-pointer' onClick={() => this.setState({ isEdit: true, })} /> */}
                                            </h1>
                                            // <div className='d-flex align-items-center' >
                                            //     <input type='text' autoComplete='off' style={{ width: '30%' }} value={this.state.title} className='form-control' onChange={(e) => { this.setState({ title: e.target.value }) }} /> &nbsp;&nbsp;
                                            //     <h2 onClick={this.saveTitle} style={{ color: '#8b7df2', cursor: 'pointer' }}>Save</h2>
                                            // </div>
                                        )
                                        :
                                        <small style={{ fontFamily: 'Roboto', fontSize: 14, color: '#535259' }}>Job title not selected</small>
                                }
                                {<div style={{ display: 'flex', justifyContent: 'center', borderBottom: '2px solid #5FBB97', padding: '3px 10px', width: '100%' }}></div>}
                            </div>
                            <div className='skill-mapping'>
                                <h3>
                                    <div>
                                        Skill Mapping
                                        <p style={{ fontWeight: 400 }}>The following skills are mapped to "<strong>{jobTitle}</strong>".</p>
                                    </div>
                                    {((!this.state.edit1) ? <button onClick={() => this.setState({ edit1: true })} className='button-color cursor-pointer'>Add /Edit Skills</button> : null)}
                                </h3>

                                {(!this.state.edit1) ?
                                    (
                                        <div className='mt-3'>
                                            <DragDropContext onDragEnd={this.handleOnDragEnd}>
                                                <Droppable droppableId='skills'>
                                                    {(provided) => (
                                                        <div className='selected-skills' {...provided.droppableProps} ref={provided.innerRef}>
                                                            {
                                                                selectedJobTitleSkills?.map((it, index) => {
                                                                    // eslint-disable-next-line eqeqeq
                                                                    return (
                                                                        <Draggable draggableId={it.skill_id} index={index} key={it.skill_id}>
                                                                            {(provided) => (
                                                                                <div className={'sub mb-2'} ref={provided.innerRef} {...provided.draggableProps} {...provided.dragHandleProps}>
                                                                                    <p className='elipsis' title={it.title}>
                                                                                        <img src={it.image} alt='' width={48} height={36} className='rounded' style={{ verticalAlign: 'middle' }} onError={(e) => {
                                                                                            if (e.target.src !== "https://elite-skill-images.s3.ap-south-1.amazonaws.com/Competitive+Intelligence.png") {
                                                                                                e.target.onerror = "https://elite-skill-images.s3.ap-south-1.amazonaws.com/Competitive+Intelligence.png";
                                                                                                e.target.src = "https://elite-skill-images.s3.ap-south-1.amazonaws.com/Competitive+Intelligence.png";
                                                                                            }
                                                                                        }} />&nbsp;&nbsp;
                                                                                        {it.title}
                                                                                    </p>
                                                                                    <p >
                                                                                        <img src='/images/list-color.svg' style={{ verticalAlign: 'middle', width: 16, height: !6 }} alt='' />&nbsp;{it.articles + it.videos + it.documents + it.podcasts + it.courses} Items
                                                                                    </p>
                                                                                    {/* <img src='/images/close-gray.svg' alt='' onClick={() => this.props.removeSkill(it.skill_id)} /> */}
                                                                                </div>
                                                                            )}
                                                                        </Draggable>
                                                                    )
                                                                })
                                                            }
                                                            {provided.placeholder}
                                                        </div>
                                                    )}
                                                </Droppable>
                                            </DragDropContext>
                                        </div>
                                    ) :
                                    (
                                        <div className='mt-3'>
                                            <div className='skill-search'>
                                                <div className="has-search"  >
                                                    <span className="form-control-feedback">
                                                        <img src="/images/search.svg" width="14" alt='' />
                                                    </span>
                                                    <input type='search' name='student' placeholder='Search for skill' id='search' value={this.state.skillQuery} autoComplete='off' className='form-control' onChange={(e) => this.changeSkill(e.target.value)} />
                                                    {
                                                        skillSuggestions !== undefined && this.state.skillQuery !== '' && skillSuggestions.length > 0 ?
                                                            <div id='suggestion-container' className="job-title-suggestion" >
                                                                <ul>
                                                                    {
                                                                        skillSuggestions.length > 0 ?
                                                                            skillSuggestions.map((items, i) => {
                                                                                return (

                                                                                    <li key={items?._id} onClick={() => this.selectSkill(items)} style={{ height: 'unset' }}>
                                                                                        <div className="row">
                                                                                            <div className="d-flex align-items-center w-100">
                                                                                                <p className='text-left' style={{ width: '55%' }} >
                                                                                                    <img src={items.image} alt='' width={48} height={36} className='rounded' style={{ verticalAlign: 'middle' }} onError={(e) => {
                                                                                                        if (e.target.src !== "https://elite-skill-images.s3.ap-south-1.amazonaws.com/Competitive+Intelligence.png") {
                                                                                                            e.target.onerror = "https://elite-skill-images.s3.ap-south-1.amazonaws.com/Competitive+Intelligence.png";
                                                                                                            e.target.src = "https://elite-skill-images.s3.ap-south-1.amazonaws.com/Competitive+Intelligence.png";
                                                                                                        }
                                                                                                    }} />&nbsp;&nbsp;
                                                                                                    {items.title}
                                                                                                </p>
                                                                                                <p style={{ width: '30%' }}>
                                                                                                    <img src='/images/list-color.svg' style={{ verticalAlign: 'middle', width: 16, height: 16 }} alt='' />&nbsp;{items.articles + items.videos + items.documents + items.podcasts + items.courses} Items
                                                                                                </p>
                                                                                                <button className='button-color' style={{ width: '12%' }}>Add</button>
                                                                                            </div>
                                                                                        </div>
                                                                                    </li>
                                                                                )
                                                                            }) : null
                                                                    }
                                                                </ul>
                                                            </div> : null
                                                    }
                                                </div>
                                            </div>
                                            <DragDropContext onDragEnd={this.handleOnDragEnd}>
                                                <Droppable droppableId='skills'>
                                                    {(provided) => (
                                                        <div className='selected-skills mt-2' {...provided.droppableProps} ref={provided.innerRef}>
                                                            {
                                                                selectedJobTitleSkills?.map((it, index) => {
                                                                    // eslint-disable-next-line eqeqeq
                                                                    return (
                                                                        <Draggable draggableId={it.skill_id} index={index} key={it.skill_id}>
                                                                            {(provided) => (
                                                                                <div className={'sub mb-2 justify-content-unset'} ref={provided.innerRef} {...provided.draggableProps} {...provided.dragHandleProps}>
                                                                                    <p >
                                                                                        <img src='/images/drag.svg' alt='' />&nbsp;&nbsp;&nbsp;&nbsp;
                                                                                        <img src={it.image} alt='' width={48} height={36} className='rounded' style={{ verticalAlign: 'middle' }} onError={(e) => {
                                                                                            if (e.target.src !== "https://elite-skill-images.s3.ap-south-1.amazonaws.com/Competitive+Intelligence.png") {
                                                                                                e.target.onerror = "https://elite-skill-images.s3.ap-south-1.amazonaws.com/Competitive+Intelligence.png";
                                                                                                e.target.src = "https://elite-skill-images.s3.ap-south-1.amazonaws.com/Competitive+Intelligence.png";
                                                                                            }
                                                                                        }} />&nbsp;&nbsp;
                                                                                    </p>
                                                                                    <p style={{ width: '25%' }} className='elipsis text-left' title={it.title}>{it.title} </p>
                                                                                    <p style={{ width: '50%' }}>
                                                                                        <img src='/images/list-color.svg' style={{ verticalAlign: 'middle', width: 16, height: 16 }} alt='' />&nbsp;{it.articles + it.videos + it.documents + it.podcasts + it.courses} Items
                                                                                    </p>
                                                                                    <img src='/images/delete.svg' alt='' onClick={() => this.props.removeSkill(it)} />
                                                                                </div>
                                                                            )}
                                                                        </Draggable>
                                                                    )
                                                                })
                                                            }
                                                            {provided.placeholder}
                                                        </div>
                                                    )}
                                                </Droppable>
                                            </DragDropContext>

                                        </div>
                                    )
                                }
                            </div>
                            {/* <div className="close-sticky" onClick={this.handleModal}>
                                <img src="/images/close.svg" width='15px' alt='' />
                            </div> */}
                            {

                                <div className='save-btns  mt-2'>
                                    <button className='button-color' onClick={() => this.updatejobTitle()}>Start Learning</button> &nbsp;&nbsp;&nbsp;
                                    {/* <h3 className='cursor-pointer' onClick={() => this.setState({ edit1: false })} >Cancel</h3> */}
                                </div>
                            }
                            {/* <div className='save-btn float-left mt-3 '>
                            <button className='button-color' onClick={this.saveOtherSkill}>{t('Save')}</button>
                            <button onClick={() => this.handleModal()} >{t('Cancel')}</button>
                        </div> */}

                        </Modal.Body>
                    </Modal>
                }
                {/* Model for youtube Intro Video */}

                <Modal
                    show={this.state.clickBtn}
                    size="lg"
                    aria-labelledby="contained-modal-title-vcenter"
                    centered
                    dialogClassName={"intro-video"}
                >
                    {<div
                        className="sticky-close"
                        onClick={() => this.closeVideo()}
                    >
                        <img src="/images/close-white.svg" alt='' />
                    </div>}
                    <div className="main-modal-header">
                        <h3>{window.location.pathname === '/learn' ? 'Take a video walk-through of Learn section' : window.location.pathname === '/analytics' ? 'Take a video walk-through of Analytics section' : window.location.pathname === '/saved' ? 'Take a video walk-through of Saved section' :
                            window.location.pathname === '/profile' ? 'Take a video walk-through of Profile section' : window.location.pathname === '/users' ? 'Take a video walk-through of Users section' : window.location.pathname === '/job-titles' ? 'Take a video walk-through of Job-title section' :
                                window.location.pathname === '/my-content' ? 'Take a video walk-through of My Content section' : window.location.pathname === '/tests' ? 'Take a video walk-through of Test section' : window.location.pathname === '/mentors' ? 'Take a video walk-through of Mentor section' : null}
                        </h3>
                    </div>
                    <div className='p-3'>
                        <ReactPlayer url={window.location.pathname === '/learn' ? 'https://youtu.be/dBQP8KXTkWg' : window.location.pathname === '/analytics' ? 'https://www.youtube.com/watch?v=7sFUMihkQAg&ab_channel=Elite' : window.location.pathname === '/saved' ? 'https://www.youtube.com/watch?v=G02_6NTARPw&feature=youtu.be&ab_channel=Elite' :
                            window.location.pathname === '/profile' ? 'https://www.youtube.com/watch?v=G02_6NTARPw&feature=youtu.be&ab_channel=Elite' : window.location.pathname === '/users' ? 'https://www.youtube.com/watch?v=BKDWpzTS4qo&ab_channel=Elite' : window.location.pathname === '/job-titles' ? 'https://www.youtube.com/watch?v=vWTYky61MUI&ab_channel=Elite' :
                                window.location.pathname === '/my-content' ? 'https://www.youtube.com/watch?v=LCpb-tsbLrE&feature=youtu.be' : window.location.pathname === '/tests' ? 'https://youtu.be/RtD3gJQBDOQ' : window.location.pathname === '/mentors' ? 'https://youtu.be/xZozTV6uTBE' : null}
                            controls
                            playing={true}
                            // muted
                            width='100%'
                            onProgress={(progress) => this.onProgress(progress)}
                            height={window.innerWidth < 767 ? 180 : 360}
                        />
                    </div>
                </Modal>

                <Modal
                    show={this.state.nofound}
                    size="lg"
                    aria-labelledby="contained-modal-title-vcenter"
                    centered
                    dialogClassName={"intro-video"}
                >
                    {<div
                        className="sticky-close"
                        onClick={() => this.setState({ nofound: false })}
                    >
                        <img src="/images/close-white.svg" alt='' />
                    </div>}
                    <div className="main-modal-header">
                        <h3>{'Take a video walk-through of Product'}
                        </h3>
                    </div>
                    <div className='p-3'>
                        <ReactPlayer url={'https://www.youtube.com/watch?v=SULi9IB3GQg'}
                            controls
                            playing={true}
                            // muted
                            width='100%'
                            // onProgress={(progress) => this.onProgress(progress)}
                            height={window.innerWidth < 767 ? 180 : 360}
                        />
                    </div>
                </Modal>
                {/* ########## Confirm  modal ############### */}
                <Modal
                    show={this.state.isConfirm}
                    size="md"
                    aria-labelledby="contained-modal-title-vcenter"
                    centered
                    dialogClassName={"confirm-modal"}
                >
                    <div className="p-1 text-center">

                        <div className="text-center d-flex flex-column align-items-center p-2 ">
                            <h1 className="mt-1" style={{ fontSize: 18 }}>Are you sure to leave so soon ?</h1>
                            <div className="login-loader">
                                {/* <Lottie options={defaultOptions} height={120} width={150} /> */}
                                <img src='/images/take-tour.gif' alt='' />
                            </div>
                            <h1 className="mt-1" style={{ fontSize: 18 }}>Click on 'Take a tour' to watch the walk-through video anytime</h1>
                            <div className='save-btn'>
                                <button onClick={this.seenConfirm} >{t('Close')}</button>&nbsp;&nbsp;
                                <button onClick={this.closeModal} >{t('Continue watching')}</button>
                            </div>
                        </div>

                    </div>
                </Modal>
            </Fragment >

        )
    }
}

const mapStateToProps = (state) => {
    const { notifications, unread, searchSuggestions } = state.sidebar
    const { selectedJobTitleSkills, suggestedSkills, exist, jobTitle, skillSuggestions, roleId } = state.jobtitle
    const { rewardList } = state.adminReward
    const { testList } = state.adminTest
    const { contents } = state.content
    const { isShow } = state.learn
    const { companyDetails, theme } = state.account
    const { profiledetails } = state.profile
    return {
        companyDetails, notifications, unread, searchSuggestions, profiledetails, isShow,
        selectedJobTitleSkills, suggestedSkills, exist, jobTitle, skillSuggestions, roleId, contents, rewardList, testList,
        theme
    }
}

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
        getCompanyDetail, gerColorCodes, getPlans, updateAlert, getNotifications, trackUserLogin, markedRead, logOutUser, logOutFromDevices, getSearchSuggestion, getNextSuggestion, saveProfile, getProfileDetails, getRoleSkills, removeSkill, reorderSkills,
        searchSkills, addSkilltoSelected, getSuggestedSkills, updatejobTitles, getSkills, getContentList, getTestList, getRewardsList, clearErrors
    }, dispatch)
}
export default withTranslation(['common', 'profile', 'reward'])(connect(mapStateToProps, mapDispatchToProps)(withRouter(Sidebar)));
